import { useState, useEffect } from "react";
import BookingModal from './BookingModal';
import BookingOverviewModal from './BookingOverviewModal';
import { scrollToTarget } from '../../utils/scrollUtils';
import { isEmailFormatCorrect } from '../../utils/formUtils';
import FloatingLabelInput from '../common/inputs/FloatingLabelInput';
import useFetchGraphQL from "../../hooks/useFetchGraphQL";

const BookingOverviewForm = ({ t, bookingInfo }) => {
    const [isBookingOverviewModalOpen, setIsBookingOverviewModalOpen] = useState(false);
    const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);
    const [initialStepOfBookingModal, setInitialStepOfBookingModal] = useState(false);
    const [booking, setBooking] = useState({});
    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState(false);
    const [bookingCode, setBookingCode] = useState('');
    const [loading, setLoading] = useState(false);
    const { fetchBookingByPk } = useFetchGraphQL();


    const textTitle=t("pages.booking_overview.texts.text1", { returnObjects: true });
    const text2=t("pages.booking_overview.texts.text2", { returnObjects: true });
    const text3=t("pages.booking_overview.texts.text3", { returnObjects: true });
    const text4=t("pages.booking_overview.texts.text4", { returnObjects: true });
    const text5=t("pages.booking_overview.texts.text5", { returnObjects: true });
    const textButton=t("pages.booking_overview.texts.text6", { returnObjects: true });
    const textP=t("pages.booking_overview.texts.text7", { returnObjects: true });
    const text8=t("pages.booking_overview.texts.text8", { returnObjects: true });
    const text9=t("pages.booking_overview.texts.text9", { returnObjects: true });

    const handleSubmit = async (e) => {
      e.preventDefault();

      setEmailError(false);
      if (!isEmailFormatCorrect(email)) {
        setEmailError(true);
        return;
      }
  
      setLoading(true);
      fetchBookingByPk(bookingCode, email.toLowerCase())
      .then((response) => {
        const bookingByPk = JSON.parse(JSON.stringify(response.data.data.booking_by_pk));
        setBooking(bookingByPk);
        setIsBookingOverviewModalOpen(true);
        })
      .catch(() => { 
        setInitialStepOfBookingModal('error')
        setIsBookingModalOpen(true);
       })
       .finally(() => {
         setLoading(false);
       });
    };
  
    const closeBookingOverviewModal = (modalStep) => {
      if (modalStep === 'payment' || modalStep === 'cancellation') {
        setIsBookingOverviewModalOpen(false);
        setIsBookingModalOpen(true);
        setInitialStepOfBookingModal(modalStep);
      } else {
        setBooking({});
        setIsBookingOverviewModalOpen(false);
      }
      setTimeout(() => {
        scrollToTarget("booking-overview-form");
      }, 100);
    };

    const closeBookingModal = () => {
      setBooking({});
      setIsBookingModalOpen(false);
      setTimeout(() => {
        scrollToTarget("booking-overview-form");
      }, 100);
    };

    useEffect(() => {
      if (bookingInfo) {
        setEmail(bookingInfo.email || '');
        setBookingCode(bookingInfo.code || '');
        setTimeout(() => {
          scrollToTarget("booking-overview-form");
        }, 100);
      }
    }, [bookingInfo]);

    return (
      <>
        <form id="booking-overview-form" className="booking-form" onSubmit={handleSubmit}>
            <div className="booking-form-header">
              <h2 className="booking-form-title">{textTitle}</h2>
              <div className="generic-separator-mobile" />
              <p className="booking-form-header-p" onClick={() => scrollToTarget("booking-form")}>{text8} ⇧</p>
              <div className="generic-separator-web" />
            </div>

            <p className="booking-form-p">{textP}</p>
            <div className="input-container">
              <FloatingLabelInput label={text2} value={email} onChange={(e) => setEmail(e.target.value)} error={emailError} />
              <FloatingLabelInput label={text4} value={bookingCode} onChange={(e) => setBookingCode(e.target.value)} />
            </div>
            {loading && <div className="loading-spinner" style={{height: "40px"}}><span>{text9}</span></div>}
            {!loading && <button type="submit" className="booking-form-button" disabled={!(email !== '' && bookingCode !== '')}>{textButton}</button>}
        </form>
        {isBookingOverviewModalOpen && <BookingOverviewModal t={t} booking={booking} onClose={(modalStep) => {closeBookingOverviewModal(modalStep)}} />}
        {isBookingModalOpen && <BookingModal 
          t={t}
          booking={booking}
          isAvailable={true}
          initialModalStep={initialStepOfBookingModal}
          onClose={closeBookingModal}
          origin={"overview"}
        />}

      </>
    );
  };
  
  export default BookingOverviewForm;